
import 'epic-spinners/dist/lib/epic-spinners.min.css'
import {BreedingRhombusSpinner } from 'epic-spinners/dist/lib/epic-spinners.min.js'

export default {
  name: "Spinner",
  mixins: [],
  components: {BreedingRhombusSpinner },
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
